module.exports = __webpack_public_path__ + "static/media/welcome_to_troopr_card.0191b429.svg";